// extracted by mini-css-extract-plugin
export default {"root":"AdsenseForSearch-module-root","loaded":"AdsenseForSearch-module-loaded","title":"AdsenseForSearch-module-title"};